import React, { FC } from 'react';
import cx from 'classnames';
import { PromptCardStatusLabelTitle } from '../PromptCard/PromptCardStatusLabelTitle';
import { PromptSettingsLiveStatus } from '../Prompt/constants';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import { PromptDetailsDistanceTimer } from './PromptDetailsDistanceTimer';
import { TPromptSettingsProps } from '../PromptCard/types';
import { formatPromptSettingsDate } from '../PromptCard/utils/formatPromptSettingsDate';
import Typo from '../Typography/Typo';
import { calculateProgress } from './utils/calculateProgress';
import { useDistanceTimer } from './hooks/useDistanceTimer';

type TPromptDetailsLiveCardProps = {
  promptSettings: TPromptSettingsProps;
};

export const PromptDetailsLiveCard: FC<TPromptDetailsLiveCardProps> = ({ promptSettings }) => {
  const { liveStatus, startDate, endDate } = promptSettings || {};
  const formattedDistanceText = useDistanceTimer(startDate, endDate, liveStatus);

  const currentDate = new Date();
  const formattedStartDate = new Date(startDate);
  const formattedEndDate = new Date(endDate);
  const isCompleted = currentDate > formattedEndDate;
  const hasStarted = currentDate >= formattedStartDate;

  return (
    <div className="grid max-w-[368px] gap-5 bg-t2-shades-white px-4 py-6 rounded-xl">
      <div
        className={cx({
          'ml-3': liveStatus === PromptSettingsLiveStatus.LIVE,
        })}
      >
        <PromptCardStatusLabelTitle status={liveStatus as PromptSettingsLiveStatus} textSize="medium" />
      </div>
      <ProgressBar
        progress={calculateProgress(startDate, endDate)}
        showProgressBar={hasStarted}
        completed={isCompleted}
      />
      <PromptDetailsDistanceTimer formattedDistanceText={formattedDistanceText} />
      <Typo variant="p2">
        {formatPromptSettingsDate(startDate as string)} - {formatPromptSettingsDate(endDate as string)}
      </Typo>
      {isCompleted && (
        <Typo variant="p2" className="text-t2-primary-brandColor">
          No longer accepting new replies
        </Typo>
      )}
    </div>
  );
};
